import { getCurrentRedirectTo } from './funnelContext';
import { DASHBOARD_ROUTE_PATTERN } from './dashboardRoutes';

const APP_ROUTE_PATTERNS: RegExp[] = [
    DASHBOARD_ROUTE_PATTERN,
];

export function isAppRoute(pathname: string): boolean {
    return APP_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));
}

export function getRouteModeRedirect(pathname: string): string {
    return getCurrentRedirectTo(pathname);
}
